/**
 * Creates a throttled version of a function that only invokes the callback at most once per specified delay.
 * T - Type of the callback function.
 * @param callback - The function to throttle.
 * @param delay - Delay in milliseconds to wait before allowing the next invocation.
 * @returns A throttled function that enforces the delay between calls.
 */
export const throttle = <T extends (...args: never[]) => void>(
  callback: T,
  delay: number,
) => {
  let isWaiting = false;

  return (...args: Parameters<T>): void => {
    if (isWaiting) {
      return;
    }

    callback(...args);
    isWaiting = true;

    setTimeout(() => {
      isWaiting = false;
    }, delay);
  };
};
